var exports = {
  "d": "x127c5a35--96640f--refresh-button",
};

module.exports = exports;
